// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/settings/AccountSettings.css
// module id = 2025
// module chunks = 0